import { NbMenuItem } from '@nebular/theme';
import { NbAccessChecker } from '@nebular/security';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class AdminPagesMenu {
  constructor(private accessChecker: NbAccessChecker) {}

  getMenu(): Observable<NbMenuItem[]> {
    const userMenu: NbMenuItem = {
      title: 'Users',
      icon: 'people-outline',
      link: '/admin/users/list',
      children: undefined,
    };

    const subscriptionMenu: NbMenuItem = {
      title: 'Subscription Plans',
      icon: 'people-outline',
      link: '/admin/subscriptions/list',
      children: undefined,
    };

    const publicfoodMenu: NbMenuItem = {
      title: 'Food Groups',
      icon: { icon: 'food-outline', pack: 'custom' },
      link: '/admin/foods/list',
      children: undefined,
    };

    const publicTemplateMenu: NbMenuItem = {
      title: 'Public Templates',
      icon: 'file-text-outline',
      link: '/admin/templates/list',
      children: undefined,
    };

    return this.accessChecker.isGranted('view', 'users').pipe(
      map((hasAccess) => {
        if (hasAccess)
          return [
            userMenu,
            subscriptionMenu,
            publicfoodMenu,
            publicTemplateMenu,
          ];
        else return [];
      }),
    );
  }
}
